(() => {
  if (customElements.get('le-seven-cart-accessories')) return;
  class CartAccessories extends HTMLElement {
    connectedCallback() {
      this.onSubmit = this.submit.bind(this);
      this.addEventListener('submit', this.onSubmit);
      this.onVariantChange = (event) => {
        if (!event.target.matches('select[name="id"]')) return;
        const option = event.target.selectedOptions[0];
        const image = event.target.closest('article').querySelector('img');
        if (image && option.dataset.image) { image.src = option.dataset.image; image.removeAttribute('srcset'); image.alt = option.dataset.alt; }
      };
      this.addEventListener('change', this.onVariantChange);
      if (typeof subscribe === 'function') this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
      const panel = this.closest('cart-notification')?.querySelector('#cart-notification');
      if (panel) {
        this.observer = new MutationObserver(() => { if (panel.classList.contains('active')) this.refresh(); });
        this.observer.observe(panel, { attributes: true, attributeFilter: ['class'] });
      }
    }
    disconnectedCallback() {
      this.unsubscribe?.(); this.observer?.disconnect();
      this.removeEventListener('submit', this.onSubmit);
      this.removeEventListener('change', this.onVariantChange);
      this.controller?.abort();
    }
    async refresh() {
      this.controller?.abort(); this.controller = new AbortController();
      try {
        const url = new URL(window.Shopify.routes.root, location.origin);
        url.searchParams.set('section_id', 'le-seven-cart-accessories');
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = doc.querySelector('le-seven-cart-accessories');
        if (!incoming) throw new Error('Unavailable');
        this.innerHTML = incoming.innerHTML;
        // A cart page and a notification can coexist; keep label IDs unique.
        this.querySelectorAll('select[id]').forEach(select => {
          const label = this.querySelector(`label[for="${select.id}"]`);
          select.id = select.id.replace('Accessory-page-', `Accessory-${this.dataset.placement}-`);
          if (label) label.htmlFor = select.id;
        });
      } catch (error) {
        if (error.name !== 'AbortError') this.replaceChildren();
      }
    }
    async submit(event) {
      const form = event.target.closest('.ls-cart-accessory__form');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('button');
      if (button.disabled) return;
      button.disabled = true; button.textContent = 'Adding…';
      const status = this.querySelector('[role="status"]');
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = new FormData(form);
      if (cart) {
        const sections = cart.getSectionsToRender().map(section => section.id);
        const footer = document.querySelector('#main-cart-footer');
        if (footer) sections.push(footer.dataset.id);
        body.append('sections', sections.join(','));
        body.append('sections_url', window.location.pathname);
        cart.setActiveElement?.(button);
      }
      let added = false;
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body, headers: { Accept: 'application/json' } });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'Could not add this option. Please try again.');
        added = true;
        if (cart && result.sections) cart.renderContents(result);
        const footer = document.querySelector('#main-cart-footer');
        if (footer && result.sections?.[footer.dataset.id]) {
          const rendered = new DOMParser().parseFromString(result.sections[footer.dataset.id], 'text/html');
          const totals = rendered.querySelector('.js-contents');
          if (totals) footer.querySelector('.js-contents').replaceWith(totals);
        }
        if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'accessory-upsell', productVariantId: body.get('id'), cartData: result });
        await this.refresh();
        // The offer disappears after adding; move focus to the stable cart control.
        const target = document.querySelector('#cart-notification-button') || document.querySelector('#CartDrawer-Checkout') || document.querySelector('[name="checkout"]');
        target?.focus();
      } catch (error) {
        if (added) { window.location.assign(window.Shopify.routes.root + 'cart'); return; }
        if (status) status.textContent = error.message;
        button.disabled = false; button.textContent = 'Add to cart';
      }
    }
  }
  customElements.define('le-seven-cart-accessories', CartAccessories);
})();
